import { IAuthenticatedUser } from "@model/Authentication.model";
import * as actionTypes from "./UserAuthenticationActionTypes";

const loginUserAction =
  (loggedInUser: IAuthenticatedUser) => (dispatch: any) => {
    try {
      dispatch({
        type: actionTypes.LOGIN_USER,
        payload: loggedInUser,
      });
    } catch (error) {
      return;
    }
  };

export { loginUserAction };
